import { BlitzPage } from "@blitzjs/next";
import { ReCaptchaProvider } from "next-recaptcha-v3";

import { KLogoKraftfulSvg } from "app/core/components/KraftfulLogoSVG";
import { EmptyGrayLayout } from "app/core/layouts/EmptyGrayLayout";

import { BlackBorderPanel } from "app/product-research/components/common/Panel";

import { ForgotPasswordForm } from "app/forgot-password/ForgotPasswordForm";

const SetPasswordPage: BlitzPage = () => {
  return (
    <div className="flex flex-col items-center">
      <KLogoKraftfulSvg className="mt-20" width={150} />
      <BlackBorderPanel
        className="flex-grow-0 p-8 mt-12"
        style={{ width: 400, borderColor: "black" }}
      >
        <h1 className="font-medium text-lg pb-4 text-center">Set a password</h1>

        <ReCaptchaProvider useEnterprise>
          <ForgotPasswordForm />
        </ReCaptchaProvider>
      </BlackBorderPanel>
      <div className="flex flex-row">
        <a
          href="https://www.kraftful.com/terms-of-service"
          target="_blank"
          rel="noreferrer"
          className="text-black font-light mt-4"
        >
          Terms
        </a>
        <a
          href="https://www.kraftful.com/privacy-policy"
          target="_blank"
          rel="noreferrer"
          className="text-black font-light mt-4 ml-6"
        >
          Privacy
        </a>
      </div>
    </div>
  );
};

SetPasswordPage.suppressFirstRenderFlicker = true;
SetPasswordPage.getLayout = (page) => (
  <EmptyGrayLayout title="Forgot password">{page}</EmptyGrayLayout>
);

export default SetPasswordPage;
